import { Building, CloudSun, Cog, Droplet, Fan, Flame, Fuel, Snowflake, SolarPanel, Thermometer, Wind, Zap } from "lucide-react";

export const iconsPGroup = {
  Confort: <Building />,
  Environment: <CloudSun />,
  Air: <Wind />,
  Refrigeration: <Snowflake />,
  Water: <Droplet />,
  Electric: <Zap />,
  Thermal: <Thermometer />,
  Gas: <Flame />,
  Fuel: <Fuel />,
  Alternatives: <Fan />,
  Productive: <Cog />,
  Selfgeneration: <SolarPanel />,
};

export const primaryGroup = [
  "confort",
  "environment",
  "air",
  "refrigeration",
  "water",
  "electric",
  "thermal",
  "gas",
  "fuel",
  "alternatives",
  "productive",
  "selfGeneration",
];

export const secGroup = {
  confort: [
    "Temperature",
    "Heat stress",
    "Wind direction",
    "mm of rain",
    "Humidity",
    "Heat index",
  ],
  environment: [
    "Temperature",
    "Heat stress",
    "Wind direction",
    "Humidity",
    "mm of rain",
  ],
  air: ["Ventilation", "Compressed air"],
  refrigeration: ["Air conditioning", "Industrial"],
  water: [
    "Production process",
    "Recover rain",
    "Treatment",
    "Wastewater discharge",
  ],
  electric: ["Motor", "Lighting", "Heating", "Refrigeration", "Compressed air"],
  thermal: ["Process steam", "Heating", "Boilers"],
  gas: ["Production process", "Heating", "Boilers"],
  fuel: ["Waste materials", "Gas Oil", "GLP", "GNC", "Fuel-Oil"],
  alternatives: [
    "Waste materials",
    "Wind energy",
    "Solar energy",
    "Solar thermal energy",
    "Geothermal energy",
    "Hydraulic energy",
    "Tidal energy",
  ],
  productive: [
    "Fans and Pumps",
    "Compressors and Turbines",
    "Heat Recovery",
    "Waste materials",
    "Water",
    "Motors",
  ],
  selfGeneration: [
    "Gas generator",
    "Gas-oil generator",
    "Dual fuel generator",
    "Thermal power plant",
  ],
};

export const parametrosSelect = [
  { id: 1, abreviado: "T", name: "TEMPERATURA" },
  { id: 2, abreviado: "H", name: "HUMEDAD" },
  { id: 3, abreviado: "PA", name: "POTENCIA ACTIVA" },
  { id: 4, abreviado: "EA", name: "ENERGIA ACTIVA" },
  { id: 5, abreviado: "PI", name: "POTENCIA INDUCTIVA" },
  { id: 6, abreviado: "EI", name: "ENERGIA INDUCTIVA" },
  { id: 7, abreviado: "V", name: "TENSION" },
  { id: 8, abreviado: "A", name: "CORRIENTE" },
  { id: 9, abreviado: "COSθ", name: "COSENO FI" },
  { id: 10, abreviado: "FP", name: "FACTOR DE POTENCIA" },
  { id: 11, abreviado: "EAE", name: "ENERGIA ACTIVA EXPORTADA" },
  { id: 12, abreviado: "EAI", name: "ENERGIA ACTIVA IMPORTADA" },
  { id: 13, abreviado: "CPA", name: "PULSOS ANALOGICOS" },
  { id: 14, abreviado: "CPD", name: "PULSOS DIGITALES" },
];

export const tipoEquipos = [
  {
    value: "CONCENTRADOR PARAMETROS ELECTRICOS",
    label: "CONCENTRADOR PARAMETROS ELECTRICOS",
  },
  {
    value: "CONCENTRADOR DE PULSOS ANALOGICOS",
    label: "CONCENTRADOR DE PULSOS ANALOGICOS",
  },
  {
    value: "CONCENTRADOR DE PULSOS DIGITAL",
    label: "CONCENTRADOR DE PULSOS DIGITAL",
  },
  {
    value: "CONCENTRADOR DE DATOS MODBUS",
    label: "CONCENTRADOR DE DATOS MODBUS",
  },
  { value: "SENSOR ANALOGICO", label: "SENSOR ANALOGICO" },
  { value: "SENSOR DIGITAL", label: "SENSOR DIGITAL" },
];

export const timeZones = [
  {
    value: "GMT-4",
    label: "America/New_York (GMT-4)",
  },
  {
    value: "GMT-7",
    label: "America/Los_Angeles (GMT-7)",
  },
  {
    value: "GMT",
    label: "Europe/London (GMT)",
  },
  {
    value: "GMT+1",
    label: "Europe/Madrid (GMT+1)",
  },
  {
    value: "GMT+9",
    label: "Asia/Tokyo (GMT+9)",
  },
  {
    value: "GMT+4",
    label: "Asia/Dubai (GMT+4)",
  },
  {
    value: "GMT-3",
    label: "America/Argentina/Buenos_Aires (GMT-3)",
  },
  {
    value: "GMT+11",
    label: "Australia/Sydney (GMT+11)",
  },
];

export const updateConsumptionState = (partial) => {
  try {
    const savedStr = localStorage.getItem("consumption_state");
    const prev = savedStr ? JSON.parse(savedStr) : {};
    let next = { ...prev, ...partial };

    if (Array.isArray(next.devicesSelected)) {
      next.devicesSelected = next.devicesSelected.map((device) => ({
        value: device.value,
        label: device.label,
        mac: device.mac,
      }));
    }

    localStorage.setItem("consumption_state", JSON.stringify(next));
  } catch (e) {
    console.error("Error actualizando consumption_state", e);
  }
};

export const getInitialDatesFromStorageOrToday = (
  storageKey = "consumption_state"
) => {
  try {
    const savedStr = localStorage.getItem(storageKey);

    if (savedStr) {
      const saved = JSON.parse(savedStr);

      if (saved.startDate && saved.endDate) {
        return {
          startDate: new Date(saved.startDate),
          endDate: new Date(saved.endDate),
          fromStorage: true,
        };
      }
    }
  } catch (e) {
    console.error("Error leyendo fechas desde localStorage", e);
  }

  const now = new Date();
  const start = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0,
    0
  );
  const end = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59,
    999
  );

  return {
    startDate: start,
    endDate: end,
    fromStorage: false,
  };
};

export const getDeviceFkByLevel = (device, level) => {
  switch (level) {
    case "branch_offices":
      return device?.branch_fk;
    case "branch_office_place":
      return device?.place_fk;
    case "place_zone":
      return device?.zone_fk;
    case "zone_local":
      return device?.local_fk;
    case "company":
    default:
      return device?.company_fk;
  }
};

export const deviceMatchesAnySelection = (device, selections) => {
  if (!Array.isArray(selections) || selections.length === 0) return false;

  for (const sel of selections) {
    const level = sel?.level || "company";
    const selId = Number(sel?.id);
    const selCompanyId =
      level === "company" ? Number(sel?.id_company) : NaN;

    const fk = Number(getDeviceFkByLevel(device, level));
    if (!Number.isFinite(fk)) continue;
    if (Number.isFinite(selId) && fk === selId) return true;
    if (Number.isFinite(selCompanyId) && fk === selCompanyId) return true;
  }

  return false;
};
